var $45375701f409adf1$exports = {};
$45375701f409adf1$exports = {
  "dismiss": "Zru\u0161i\u0165"
};
export { $45375701f409adf1$exports as default };